import { render, staticRenderFns } from "./CropTab.vue?vue&type=template&id=0d877d1c&scoped=true&"
import script from "./CropTab.vue?vue&type=script&lang=js&"
export * from "./CropTab.vue?vue&type=script&lang=js&"
import style1 from "./CropTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d877d1c",
  null
  
)

export default component.exports